var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDullFeatureArrowLeftBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1776EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4416 12.0631C18.3709 11.9903 18.2867 11.9325 18.1941 11.893C18.1014 11.8536 18.0019 11.8333 17.9015 11.8333C17.8011 11.8333 17.7017 11.8536 17.609 11.893C17.5163 11.9325 17.4322 11.9903 17.3615 12.0631L13.5582 15.9482C13.487 16.0205 13.4304 16.1064 13.3918 16.2011C13.3531 16.2958 13.3333 16.3973 13.3333 16.4999C13.3333 16.6025 13.3531 16.7041 13.3918 16.7987C13.4304 16.8934 13.487 16.9794 13.5582 17.0516L17.3615 20.9367C17.4322 21.0096 17.5163 21.0674 17.609 21.1068C17.7017 21.1463 17.8011 21.1666 17.9015 21.1666C18.0019 21.1666 18.1014 21.1463 18.1941 21.1068C18.2867 21.0674 18.3709 21.0096 18.4416 20.9367C18.5129 20.8645 18.5695 20.7786 18.6081 20.6839C18.6467 20.5892 18.6666 20.4876 18.6666 20.3851C18.6666 20.2825 18.6467 20.1809 18.6081 20.0862C18.5695 19.9915 18.5129 19.9056 18.4416 19.8334L15.1708 16.4999L18.4416 13.1665C18.5129 13.0942 18.5695 13.0083 18.6081 12.9136C18.6467 12.8189 18.6666 12.7174 18.6666 12.6148C18.6666 12.5122 18.6467 12.4106 18.6081 12.316C18.5695 12.2213 18.5129 12.1353 18.4416 12.0631Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDullFeatureArrowLeftBtn);
export default __webpack_public_path__ + "static/media/dull_feature_arrow_left_btn.0635ab79e184e6d272a0351f9e4591d4.svg";
export { ForwardRef as ReactComponent };